import { useNetworkPricesStore } from '../NetworkPrices.store';
import { ProductsToBePricedId } from '../types';

// undefined = no draft; null = the user cleared the field.
export const useClusterDraftPrice = (cellId: ProductsToBePricedId | null): number | null | undefined =>
  useNetworkPricesStore(state => (cellId === null ? undefined : state.draftPrices[cellId]));
